import { useEffect } from 'react'
import { useUser } from '@/queries/hooks/use-user'
import { getActiveMap } from '@/queries/hooks/use-user'

/**
 * Custom hook to manage dynamic page titles based on current user, account, and map
 * Falls back to "MyAssetMap" when user data is not available
 */
export const usePageTitle = (): void => {
  const { data: user, isLoading } = useUser()

  useEffect(() => {
    // Don't update title while loading
    if (isLoading) return

    let newTitle = 'MyAssetMap' // Default fallback

    if (user?.isLoggedIn && user.accounts) {
      // Find current account
      const currentAccount = user.accounts.find(
        account => account.id === user.accountID
      )

      if (currentAccount) {
        const accountName = currentAccount.name

        // Find current map
        const currentMap = getActiveMap(user)

        if (currentMap) {
          // Format: "Map Name - Account Name - MyAssetMap"
          newTitle = `${accountName} (${currentMap.name}) - MyAssetMap`
        } else {
          // Format: "Account Name - MyAssetMap" (when no map is selected)
          newTitle = `${accountName} - MyAssetMap`
        }
      }
    }

    // Only update if the title has changed
    if (document.title !== newTitle) {
      document.title = newTitle
    }
  }, [user, isLoading])
}
